import { pathname } from "#src/config/pathname";
import workspaceServices from "#src/services/workspace";
import { apiErrorHandler } from "#src/utils/apiErrorHandler";
import { generatePath, redirect } from "react-router-dom";

export const endpointCatcherLoader = async () => {
  // fetch workspace list, if it's empty, navigate to new workspace
  const workspaceList = await workspaceServices
    .list_workspaces()
    .catch(apiErrorHandler);

  if (workspaceList && workspaceList.length >= 1) {
    return redirect(
      generatePath(pathname.ENDPOINT_OVERVIEW, {
        workspaceId: workspaceList[0].id,
      })
    );
  } else {
    return redirect(pathname.NEW_WORKSPACE);
  }
};

export const trustCenterCatcherLoader = async () => {
  // fetch workspace list, if it's empty, navigate to new workspace
  const workspaceList = await workspaceServices
    .list_workspaces()
    .catch(apiErrorHandler);

  if (workspaceList && workspaceList.length >= 1) {
    return redirect(
      generatePath(pathname.TRUST_CENTER_POLICY, {
        workspaceId: workspaceList[0].id,
      })
    );
  } else {
    return redirect(pathname.NEW_WORKSPACE);
  }
};
